var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    [
      _c("li", { staticClass: "empty top-spacer" }),
      _vm._v(" "),
      _vm._l(_vm.menuEmpty, function(item) {
        return _c("li", { staticClass: "empty" })
      }),
      _vm._v(" "),
      _vm._l(_vm.menuItems, function(menuItem, mi) {
        return _c(
          "li",
          { class: { open: _vm.menuSubOpen === mi, active: menuItem.active } },
          [
            _c(
              "a",
              {
                attrs: { href: _vm.resolvedLink(menuItem.link) },
                on: {
                  click: function($event) {
                    return _vm.openSubMenu($event, mi)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.__t(menuItem.title)))]
            ),
            _vm._v(" "),
            menuItem.sub && menuItem.sub.length
              ? _c(
                  "ul",
                  { class: { "filter-head": menuItem.isFilter } },
                  _vm._l(menuItem.sub || [], function(menuItem2, mi2) {
                    return _c("li", { class: { dw: menuItem2.mode == "dw" } }, [
                      _c(
                        "a",
                        {
                          attrs: { href: _vm.resolvedLink(menuItem2.link) },
                          on: {
                            click: function($event) {
                              return _vm.clickItem(_vm.menuItem3)
                            }
                          }
                        },
                        [_vm._v(_vm._s(menuItem2.title))]
                      ),
                      _vm._v(" "),
                      menuItem2.mode == "dw"
                        ? _c("ul", [
                            _c("li", [
                              _c("div", { staticClass: "menu-subt" }, [
                                _vm._v(_vm._s(_vm.__t(menuItem2.col1.title)))
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                _vm._l(menuItem2.col1.sub, function(
                                  menuItem3,
                                  mi3
                                ) {
                                  return _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.resolvedLink(menuItem3.link)
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.clickItem(menuItem3)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(menuItem3.title))]
                                    )
                                  ])
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("div", { staticClass: "menu-subt" }, [
                                _vm._v(_vm._s(_vm.__t(menuItem2.col2.title)))
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                _vm._l(menuItem2.col2.sub, function(
                                  menuItem3,
                                  mi3
                                ) {
                                  return _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.resolvedLink(menuItem3.link)
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.clickItem(menuItem3)
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.__t(menuItem3.title)))]
                                    )
                                  ])
                                }),
                                0
                              )
                            ])
                          ])
                        : _c(
                            "ul",
                            _vm._l(menuItem2.sub, function(menuItem3, mi3) {
                              return _c("li", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.resolvedLink(menuItem3.link)
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.clickItem(menuItem3)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.__t(menuItem3.title)))]
                                )
                              ])
                            }),
                            0
                          )
                    ])
                  }),
                  0
                )
              : _vm._e()
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }